<template>
  <div id="adminlanding" class="fill-height">
    <section class="fill-height">
      <v-container class="text-center fill-height pa-0" fluid>
        <div class="videoWrapper">
          <iframe
            :src="iframeSrc"
            scrolling="no"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "AdminReportingView",

  computed: {
    iframeSrc() {
      // console.log("Current route path:", this.$route.path);
      // Use this.$route.path to match the full path
      switch (this.$route.path) {
        case "/admin/reporting/ordersbreakdown":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/ROdFI7JAFSmsVnKOnmY6I5nGkiI3GQrA0d38jyck?org_slug=default";

        case "/admin/reporting/revenue":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/xEKlKF46iI72hnhOcKnAYK9T3gUlvFsbWjYCVJXp?org_slug=default";

        case "/admin/reporting/revenuegrowth":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/BpNAS3sQhUtTb85p4qYJuNa7twWmKomwf2s09p0v?org_slug=default";

        case "/admin/reporting/ecwidrevenue":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/7kcKy700IINIiobflcHavjf8IYb7N9el2VkkygpO?org_slug=default";

        case "/admin/reporting/orders":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/xYHliPjU7G94pN13qq51TY5ZKglQ1uNoobdGcZyg?org_slug=default";

        case "/admin/reporting/ecwidorders":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/A18Fd58Fg1EUCkubOGDz6qNtybRmMpr9nIu4Hyji?org_slug=default";

        case "/admin/reporting/buyerratio":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/KLHbq4YqrxQaUawbgNG20Xlni4SbjbBNizr6m8oA?org_slug=default";

        case "/admin/reporting/teacherprofiles":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/68EHHp7mivqAQ1emZELWM9PxAQPHJwavNv5Rt2Ol?org_slug=default";

        case "/admin/reporting/subscriptions":
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/pxGXPgG0IH8oYsSgvniCNr8ErQeSpZlsKpoqzwa5?org_slug=default";

        default:
          return "https://redash.missanrisclassnetwork.co.za/public/dashboards/xEKlKF46iI72hnhOcKnAYK9T3gUlvFsbWjYCVJXp?org_slug=default";
      }
    },
  },
};
</script>

<style scoped>
#adminlanding,
section,
.v-container {
  height: 100vh;
}

.videoWrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
